import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { TextInput } from 'components/DesignSystem/TextInput';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string;
    isSelected?: boolean;
}

export const RelatedActivityFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    return isSelected ? (
        <div data-testid={'battlecards-filters-related-activity'} className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <TextInput
                        id={'battlecards-filters-related-activity'}
                        {...field}
                        onChange={(e) => {
                            methods?.setValue(name, e.target.value);
                            handleFilters?.();
                        }}
                        value={value ?? ''}
                        placeholder={'Related Activity...'}
                        onClear={() => {
                            methods?.setValue(name, '');
                        }}
                        maxLength={300}
                        label={FilterLabels.RELATED_ACTIVITY}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
